import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';
import { getBreakpoint } from 'wanderu-utils';

const sendEvent = (action, label, property) => SnowplowService.fireStructuredEvent({
    action,
    category: 'trip_refresh_modal',
    label,
    property,
});

const clickSkipEvent = ({ direction, funnelStage }) => {
    sendEvent('click', 'skip');

    amplitude.track('search_interacted', {
        breakpoint: getBreakpoint(),
        declined_method: 'skip_button',
        funnel_stage: funnelStage,
        interaction_type: 'pricing_refresh_declined',
        is_departing_results: direction === 'depart',
    });
};
const clickRefreshEvent = ({ direction, funnelStage }) => {
    sendEvent('click', 'refresh');

    amplitude.track('search_interacted', {
        breakpoint: getBreakpoint(),
        funnel_stage: funnelStage,
        interaction_type: 'pricing_refresh_accepted',
        is_departing_results: direction === 'depart',
    });
};
const clickScrimEvent = ({ direction, funnelStage }) => {
    sendEvent('click', 'scrim');

    amplitude.track('search_interacted', {
        breakpoint: getBreakpoint(),
        declined_method: 'scrim_click',
        funnel_stage: funnelStage,
        interaction_type: 'pricing_refresh_declined',
        is_departing_results: direction === 'depart',
    });
};
const renderModalEvent = ({ direction, funnelStage }) => {
    sendEvent('rendered', direction);

    amplitude.track('search_interacted', {
        breakpoint: getBreakpoint(),
        funnel_stage: funnelStage,
        interaction_type: 'pricing_refresh_offered',
        is_departing_results: direction === 'depart',
    });
};

const events = {
    clickRefreshEvent,
    clickScrimEvent,
    clickSkipEvent,
    renderModalEvent,
};

export default events;
